import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import dashprofile from "../../../images/avatar/3.jpg";
import { FaPowerOff } from "react-icons/fa";
import AuthContext from "../../../context/UserSummary";
import "./SubHeader.css";

const SubHeader = ({ title }) => {
  const { setAuth, setIsLoggedIn, setUserSummary } = useContext(AuthContext);

  let navigate = useNavigate();

  const logout = () => {
    localStorage.clear();
    setIsLoggedIn(false);
    setAuth({});
    setUserSummary({});
    navigate("/");
  };

  return (
    <div>
      <div className="dash-home-nav">
        <h1>{title}</h1>
        <div className="logout">
          <div className="logout-left">
            <img src={dashprofile} alt="" />
            <h3>Welcome</h3>
            <span className="logout-name">,Princewill Nzube</span>
          </div>
          <div onClick={logout} className="div-power-off">
            <FaPowerOff className="power-off" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubHeader;
